export default "__VITE_ASSET__bUMJj1RZ__ 640w, __VITE_ASSET__B0dq3UZU__ 1024w, __VITE_ASSET__FCHnej6b__ 1280w";